import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { format } from 'one-util-date';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    TransformBillingDetails
} from './transform';

import {
    setAction as setBillingAction,
    selectAction as selectBillingAction,
    Billing,
    resetAction
} from 'one-state-billing-details-athena';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
import { formatIso } from 'one-util-date';

export const enum Types {
    SETBILLING = 'set-billing/set-athena',
    BILLINGDETAILS = 'one-state-billing-details/set-athena',
    STORE_DISPOSITION_CODE = "store-disposition-code",
    SETBILLINGSSUCCESS = 'set-billing-success-athena',
    SETSELECTED_ATHENA = 'one-state-subject/setselected-athena',

}

const setBilling = (payload: any) => ({ type: Types.SETBILLING, payload });
const pushtoSetBillingDetails = (payload: any) => setBillingAction(payload);
const pushSelectedBillingDataToState = (payload: any) => selectBillingAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const fetchBillingDetailsFromAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            agentId,
            teamName,
            alertnotification,
            settings:
            {
                servers,
                athenaendpoints: { getbillingdetails, apitoken },
                uisettings: {
                    dashboardapiconfig: {
                        getbillingdetails: getbillingdetailsApi
                    }
                },
                compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            //consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
            consolidated_api_invocation ? ofType(NO_CHANGE, Types.SETBILLINGSSUCCESS) : ofType(Types.SETSELECTED_ATHENA, Types.SETBILLINGSSUCCESS),
            mergeMap((action: any):any => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-athena", "getbillingDetailsAthena request", dataresponse);
                const getBillingDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let now = new Date();
                    let sixMonthPrevious = new Date(now); // Create a new Date object
                    sixMonthPrevious.setMonth(sixMonthPrevious.getMonth() - 6); // Update the month
                    const data = {
                        // "providerid": payload.providerid + "",
                        // "departmentid": payload.departmentid,
                        "PatientID": payload?.id
                    }

                    let response;
                    if (finesse_proxy_service) {
                        //response = InvokeFinesseProxy(getbillingdetails + "?PatientID=" + payload?.id, "", apitoken, locations, log, 'GET', alertnotification);
                        response = InvokeFinesseProxy(getbillingdetails, data, apitoken, locations, log, 'POST', alertnotification);

                    } else {
                        // response = server.get({
                        //     path: getbillingdetails + "?PatientID=" + payload?.id,
                        //     headers: headers
                        // })
                        response = server.post({
                            headers: headers,
                            path: getbillingdetails,
                            data: data,
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,getbillingDetailsAthena-athena",
                                    "fetch-getbillingDetails-EPIC", {
                                    responseresult
                                }
                                );
                                // SEND to ALERT snotificiton/NOCserver for errors
                                if (responseresult?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseresult
                                        });
                                    }
                                }
                                let sourceerror: ErrorObject = {
                                    source: "Billing",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return sourceerror;
                            })
                        log.debug("one-athena", "getbillingDetailsAthena response", response);
                    }
                    return from(response);
                }
                if (!getbillingdetailsApi) return []
                return getBillingDetails(dataresponse).pipe(
                    flatMap((response: any) => {
                        const actions: any = [
                            setBilling(response)
                        ];
                        if (response && (response.status >= 400 || response.type == "error")) {
                            actions.push(addAction(response));
                            let disp: Disposition = { value: "1007" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            }
                            else if (contact_center_type === "genesys") {
                                disp.meta00 = sessionStorage.getItem("name");
                                disp.meta01 = sessionStorage.getItem("agentName");
                            }
                            else if (contact_center_type === "twilio") {
                                disp.meta00 = sessionStorage.getItem("twilio_userid");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "ringcentral") {
                                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "inContact" || contact_center_type === "ringcx") {
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                            }
                            else if (contact_center_type === "vonage") {
                                disp.meta00 = sessionStorage.getItem("vonage_userid");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "wxcc") {
                                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "intermedia") {
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                            }
                            else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse?.id;
                            disp.meta03 = response.status;
                            disp.meta04 = response?.erroritems?.[0]?.error_detail;
                            disp.meta05 = "Failed to fetch the Billing information"
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "190" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            }
                            else if (contact_center_type === "genesys") {
                                disp.meta00 = sessionStorage.getItem("name");
                                disp.meta01 = sessionStorage.getItem("agentName");
                            }
                            else if (contact_center_type === "twilio") {
                                disp.meta00 = sessionStorage.getItem("twilio_userid");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "ringcentral") {
                                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "inContact" || contact_center_type === "ringcx") {
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                            }
                            else if (contact_center_type === "vonage") {
                                disp.meta00 = sessionStorage.getItem("vonage_userid");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "wxcc") {
                                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                disp.meta01 = "";
                            }
                            else if (contact_center_type === "intermedia") {
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                            }
                            else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse.id;
                            disp.meta03 = "Billing information fetched successfully"
                            actions.push(pushToDisposition(disp));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Function is used to fetch billing details
 * @param context contains settings json etc ..
 */
export const pushBillingDetailsToStateAthena = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETBILLING),
            mergeMap((action: any) => {
                /**
                 * @param response contains the appointment response
                 */
                let response = action.payload;
                log.debug("one-athena", "fetch Billing Details request", response);
                if (response) {
                    const performBillingTransformation = (datares: any) => {
                        let result = TransformBillingDetails(response, context);
                        log.debug("one-athena", "fetch Billing Details response", result);
                        return from([result]);
                    }
                    return performBillingTransformation(response).
                        pipe(
                            map((transformresponse: any) => pushtoSetBillingDetails(transformresponse.billingdata))
                        )
                }
                else {
                    return from([]);
                }
            })

        )
    }
);

/**
 * This function is used to push the default selected value
 * for billing module.
 * @param context has logger etc.
 */
export const pushSelectedBillingDataAthena = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.BILLINGDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the request to select default billing details
                 */
                let dataresponse = action.payload;
                const getRequest = (datares: any) => {
                    const billing: Billing[] = state$.value.billingdetails?.values;
                    let selectedbilling: string = "";
                    if (billing?.length > 0) {
                        selectedbilling = billing[0].AccountName;
                    }
                    log.debug("one-athena", "pushSelectedBillingData response", selectedbilling);
                    return from([selectedbilling]);
                }


                return getRequest(dataresponse).pipe(
                    map(response => pushSelectedBillingDataToState(response))
                )
            })

        )
    }
);

/**
 * Listen for component clear and intiate state clear for Billing
 * @param context  contains logger which is used for logging
 */
export const clearBillingAthena = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, billing-athena",
            "clear-billing-athena", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);